import "./Technology.css";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import heroImg from "../assets/off-img2.png";
import productImg from "../assets/product-tech.JPG";
import processImg from "../assets/1. Process.png";
import digitalImg from "../assets/Tech-Digital1.jpg";

const cards = [
    {
        title: "Process Technology",
        tagline: "Advanced manufacturing technologies for precision and consistency.",
        desc: "Our manufacturing processes integrate automation, intelligent process control and proprietary technologies to produce complex aluminium castings with exceptional quality, repeatability and operational efficiency at scale.",
        link: "/technology/tech-process",
        img: processImg,
    },
    {
        title: "Product Technology",
        tagline: "Engineering lighter, smarter and higher-performing aluminium components.",
        desc: "Working closely with customers from concept through production, we leverage advanced simulation, lightweight design and material optimization to develop innovative casting solutions that reduce weight, improve functionality and accelerate product development.",
        link: "/technology/tech-product",
        img: productImg,
    },
    {
        title: "Digitalisation",
        tagline: "Connecting people, machines and data for smart manufacturing.",
        desc: "Powered by Industry 4.0 platforms, IoT-enabled systems and integrated digital workflows, our smart factories deliver real-time visibility, predictive control and seamless operations across the manufacturing ecosystem.",
        link: "/technology/tech-digital",
        img: digitalImg,
    },
];

export default function Technology() {
    return (
        <section id="tech">
            {/* TOP SECTION */}
            <div className="technology-wrapper">
                <div className="technology-text">
                    <h3>Technology</h3>
                    <h3>
                        Engineering Innovation Across Products, Processes &amp; Digital Manufacturing
                    </h3>

                    <p>
                        Technology at Sundaram Clayton Limited (SCL) is built on continuous innovation across every stage of the manufacturing value chain. From collaborative product engineering and advanced casting technologies to Industry 4.0-enabled digital manufacturing, we combine engineering expertise with intelligent systems to deliver lightweight, high-quality aluminium solutions for global mobility.
                    </p>
                    
                </div>

                <div className="tech-hero-image">
                    <img src={heroImg} alt="Technology" />
                </div>
            </div>

            {/* 3 CARDS */}
            <div className="technology-cards">
                {cards.map((c, i) => (
                    <div className="technology-card" key={i}>
                        <div className="tech-card-image">
                            <img src={c.img} alt={c.title} className="tech-card-img-el" />
                        </div>

                        <h3>{c.title}</h3>
                        <p><strong className="tech-card-tagline">{c.tagline}</strong></p>
                        <p>{c.desc}</p>

                        <Link to={c.link} className="tech-offer-link">
                            <span>Explore ↗</span>
                        </Link>
                    </div>
                ))}
            </div>

            <Footer />
        </section>
    );
}